import i18next from 'i18next'

export const initYDRecaptcha = (initCallback, verifyCallback) => {
  if (window.ydCaptchaInit) {
    return;
  }
  // if (window.ydCaptchaIns) {
  //   execYDRecaptcha();
  //   return;
  // }
  
  // todo: locale for yd.
  // let lang = i18next.language || 'en';
  let lang = 'en';

  let width = window.innerWidth - 50;
  if (width > 320) {
    width = 320;
  }

  window.ydCaptchaInit = true;
  initNECaptcha({
    element: '#ydcaptcha',
    captchaId: 'c53dede604544aa9ac038444639a0eb6',
    mode: 'popup',
    width: `${width}px`,
    lang: lang,
    closeEnable: false,
    feedbackEnable: false,
    apiVersion: 2,
    protocol: 'https',
    popupStyles: {
      position: 'fixed',
      top: '20%'
    },
    onClose: function() {
    },
    onVerify: function(err, data) {
      if (!err) {
        // ydCaptchaIns.close();
        if (verifyCallback) verifyCallback(data?.validate);
      }
    }
  }, function (instance) {
    window.ydCaptchaInit = false;
    window.ydCaptchaIns = instance;
    if (initCallback) initCallback();
  }, function (err) {
    window.ydCaptchaInit = false;
    console.error('YD Recaptcha init failed', err);
  })
}

export const execYDRecaptcha = () => {
  window.ydCaptchaIns && window.ydCaptchaIns.verify();
}
